// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".paginated-list[data-v-22ff596c]{position:relative}.paginated-list .items-container[data-v-22ff596c]{transition:padding .2s}.footer-jump-to-next-page[data-v-22ff596c]{width:100%;margin-bottom:0.5rem}.page-navigation-enter-active[data-v-22ff596c]{-webkit-animation:fadeInDown .2s;animation:fadeInDown .2s}.page-navigation-leave-active[data-v-22ff596c]{-webkit-animation:fadeOutUp .2s;animation:fadeOutUp .2s}\n", ""]);
// Exports
module.exports = exports;
